import { computed } from "vue";
import { useRoute } from "./useRoute";
/**
 * Composable: 현재 페이지 정보 반환
 *
 * 반환값 객체에 아래 속성이 포함됩니다:
 * - `isCommercialPage` (ComputedRef<boolean>)
 *   - 제품(상업용) 페이지 여부. 현재 라우트 경로에 "research"가 포함되지 않으면 true.
 * - `currentPath` (string)
 *   - 현재 라우트의 경로 문자열. 라우트 정보가 없으면 빈 문자열을 반환합니다.
 *
 * @example
 * const { isCommercialPage, currentPath } = usePageInfo();
 * // 사용 예: watch(isCommercialPage, val => { ... })
 *
 * @returns {{ isCommercialPage: import('vue').ComputedRef<boolean>, currentPath: string }}
 */
export const usePageInfo = () => {
    const route = useRoute();
    const isCommercialPage = computed(() => !route?.path?.includes("research"));
    return { isCommercialPage, currentPath: route?.path || "" };
};
